import Vue from 'vue'
export default {
  clearNotes(state) {
    state.notes = {}
  },
  setNotes(state, notes) {
    state.notes = notes
  },
  updateNote(state, { noteId, note }) {
    const updatedNote = Object.assign({}, note)
    state.notes[noteId] = updatedNote
  },
  setRoot(state, { id, isRoot }) {
    state.notes[id].isRoot = isRoot
  },
  deleteNote(state, note) {
    Vue.delete(state.notes, note.id)
  },
  setViewmode(state, viewMode) {
    state.viewMode = viewMode
  },
  addNote(state, note) {
    const newNote = Object.assign({}, note)
    const noteId = newNote.id
    delete newNote['id']
    const notes = Object.assign({}, state.notes)
    notes[noteId] = newNote
    state.notes = notes
  },
  setUser(state, user) {
    state.user = user
  },
  setInitialized(state, initialized) {
    state.initialized = initialized
  },
  setViewMode(state, mode) {
    state.activeViewMode = mode
  },
  setSideBarCollapsed(state, sideBarCollapsed) {
    state.sideBarCollapsed = sideBarCollapsed
  }
}
